import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { motion, useReducedMotion } from 'framer-motion'

/**
 * Sweeps a panel up over the page on route change: enters from the bottom,
 * holds while the new route paints, then exits off the top. Also resets scroll
 * position while the screen is covered, which react-router doesn't do for us.
 */
export const RouteCurtain = () => {
  const { pathname, hash } = useLocation()
  const [run, setRun] = useState(0)
  const first = useRef(true)
  const reduce = useReducedMotion()

  useEffect(() => {
    // Don't play on the very first render — that's a page load, not a transition.
    if (first.current) {
      first.current = false
      return undefined
    }

    setRun((n) => n + 1)

    if (hash) return undefined
    // Jump to the top behind the curtain, once it has covered the viewport.
    const t = setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), reduce ? 0 : 420)
    return () => clearTimeout(t)
  }, [pathname, hash, reduce])

  if (reduce || run === 0) return null

  return (
    <motion.div
      key={run}
      aria-hidden="true"
      initial={{ y: '100%' }}
      animate={{ y: ['100%', '0%', '0%', '-100%'] }}
      transition={{ duration: 1, times: [0, 0.38, 0.52, 1], ease: [0.76, 0, 0.24, 1] }}
      className=" pointer-events-none fixed inset-0 z-[90] bg-panel"
    />
  )
}
